module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "zk-breadcrumb__item"
  }, [_c('span', {
    ref: "link",
    staticClass: "zk-breadcrumb__item__inner"
  }, [_vm._t("default")], 2), _c('span', {
    staticClass: "zk-breadcrumb__separator"
  }, [_vm._v(_vm._s(_vm.separator))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-630b171e"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/breadcrumb/src/breadcrumb-item.vue
// module id = 262
// module chunks = 0